<header-row [userName]="'Victoria Brown'" [userRole]="'REGIONAL MANAGER'"></header-row>

<div class="hospital-workspace page-layout">
  <nav class="breadcrumb" aria-label="Breadcrumb">
    <span class="material-icons">home</span>
    <span class="sep">›</span>
    <span>Hospital Editor</span>
  </nav>

  <div class="workspace-header">
    <div class="title-block">
      <div class="back" (click)="locationBack()" title="Back">
        <span class="material-icons">arrow_back</span>
      </div>
      <div>
        <h1 class="page-title">{{ hospital?.hospitalName }}</h1>
        <a class="practice-link" href="#" (click)="$event.preventDefault()">Link to Practice Info</a>
      </div>
    </div>
    <div class="header-controls">
      <select class="quarter-select" [(ngModel)]="selectedQuarter" (ngModelChange)="onQuarterChange()">
        <option value="default">Quarter</option>
        <option *ngFor="let quarter of quarterList" [value]="quarter.quarterName">
          {{ quarter.quarterName }}
        </option>
      </select>
    </div>
  </div>

  <!-- KPI row -->
  <div class="kpi-row" *ngIf="!isLoadingKpi; else kpiLoader">
    <div class="kpi-card">
      <div class="kpi-label">Pace</div>
      <div class="kpi-value">{{ pacePercent !== null ? pacePercent + '%' : 'No Data' }}</div>
      <div class="kpi-sub">{{ hospital?.status && hospital?.status !== 'NoData' ? getStatusLabel(hospital?.status) : 'No Data' }}</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Momentum</div>
      <div class="kpi-value momentum" [ngClass]="getMomentumClass(hospital?.momentum)">
        <span class="material-icons">{{ getMomentumIcon(hospital?.momentum) }}</span>
        {{ getMomentumLabel(hospital?.momentum) }}
      </div>
      <div class="kpi-sub">vs prior period</div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Execution Health</div>
      <div class="kpi-value exec">
        <span class="traffic-light" [ngClass]="getExecutionHealthClass(hospital?.executionHealth)"></span>
        {{ getExecutionHealthLabel(hospital?.executionHealth) }}
      </div>
    </div>
    <div class="kpi-card">
      <div class="kpi-label">Attention Required</div>
      <div class="kpi-value attention">{{ attentionSummary }}</div>
    </div>
  </div>
  <ng-template #kpiLoader>
    <div class="section-loader">
      <div class="simple-spinner"></div>
    </div>
  </ng-template>

  <div class="middle-grid">
    <!-- Hospital Notes & Documents -->
    <vc-hospital-notes-card [hospitalId]="selectedHospitalId" [currentUserId]="currentUserId" [currentUserName]="currentUserName"></vc-hospital-notes-card>

    <!-- Right panel: Meetings + Tasks -->
    <div class="card-stack">
      <div class="card meetings-card">
        <div class="card-head">
          <h2>Scheduled Meetings</h2>
          <div class="header-actions">
            <button type="button" class="icon-btn" (click)="newAddMeeting()" title="Schedule meeting">
              <span class="material-icons">add</span>
            </button>
            <button type="button" class="icon-btn" (click)="openSchedulingPage()" title="View calendar">
              <span class="material-icons">calendar_today</span>
            </button>
          </div>
        </div>
        <ng-container *ngIf="!isLoadingMeetings; else meetingsLoader">
          <div class="meeting-block" *ngIf="nextMeeting; else noMeetings">
            <div class="meeting-main" (click)="openMeetingDetail(nextMeeting)">
              <div class="next-label">Next Meeting</div>
              <div class="meeting-title">{{ nextMeeting.meetingSubject }}</div>
              <div class="meeting-meta">
                <span class="material-icons">calendar_today</span>
                {{ nextMeeting.scheduledDate | date:'MM/dd/yyyy' }}
              </div>
              <div class="meeting-meta">
                <span class="material-icons">schedule</span>
                {{ nextMeeting.startTime }} – {{ nextMeeting.endTime }}
              </div>
            </div>
            <button type="button" class="join-btn" (click)="joinMeeting(nextMeeting.joinUrl)">
              <span class="material-icons">videocam</span> Join
            </button>
          </div>
          <p-accordion *ngIf="remainingMeetings?.length" class="sub-accordion" [multiple]="true">
            <p-accordionTab header="Upcoming Meetings">
              <div class="meeting-item" *ngFor="let m of remainingMeetings">
                <div (click)="openMeetingDetail(m)">
                  <div class="meeting-title small">{{ m.meetingSubject }}</div>
                  <div class="meeting-meta small">{{ m.scheduledDate | date:'MM/dd/yyyy' }} · {{ m.startTime }}</div>
                </div>
                <button type="button" class="join-btn sm" (click)="joinMeeting(m.joinUrl)">Join</button>
              </div>
            </p-accordionTab>
          </p-accordion>
          <ng-template #noMeetings>
            <p class="empty-hint">No meetings found for today</p>
</ng-template>

<div *ngIf="isLoading"
  style="display: flex; align-items: center; justify-content: center; position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255, 255, 255, 0.95); z-index: 9999;">
  <div style="text-align: center;">
    <div class="simple-spinner" style="width:40px; height:40px; margin: 0 auto 16px;"></div>
    <div style="color:#363636; font-size: 18px;">Loading tasks...</div>
  </div>
</div>
        </ng-container>
        <ng-template #meetingsLoader>
          <div class="section-loader">
            <div class="simple-spinner"></div>
          </div>
        </ng-template>
      </div>

      <div class="card tasks-card">
        <div class="card-head">
          <h2>Tasks</h2>
          <div>
            <button type="button" class="icon-btn" (click)="openCreateTask()" title="New task">
              <span class="material-icons">add</span>
            </button>
            <button type="button" class="icon-btn" (click)="taskListPage()" title="All tasks">
              <span class="material-icons">assignment</span>
            </button>
          </div>
        </div>
        <ng-container *ngIf="!isLoadingTasks; else tasksLoader">
          <p-accordion class="tasks-accordion" [multiple]="true">
            <p-accordionTab [header]="'Past Due (' + pastDueTasks.length + ')'" *ngIf="pastDueTasks.length">
              <div class="task-line" *ngFor="let task of pastDueTasks | slice:0:5" (click)="openViewTask(task.taskId)">
                <span>{{ task.task }}</span>
                <span class="muted">Due {{ task.dueDate | date:'MM/dd/yyyy' }}</span>
              </div>
            </p-accordionTab>
            <p-accordionTab [header]="'Upcoming Tasks (' + upcomingTasks.length + ')'" *ngIf="upcomingTasks.length">
              <div class="task-line" *ngFor="let task of upcomingTasks | slice:0:5" (click)="openViewTask(task.taskId)">
                <span>{{ task.task }}</span>
                <span class="muted">Due {{ task.dueDate | date:'MM/dd/yyyy' }}</span>
              </div>
            </p-accordionTab>
          </p-accordion>
          <p *ngIf="!pastDueTasks.length && !upcomingTasks.length" class="empty-hint">No tasks for this hospital in the selected quarter.</p>
        </ng-container>
        <ng-template #tasksLoader>
          <div class="section-loader">
            <div class="simple-spinner"></div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Notes & Activity hidden temporarily -->
  <!-- <div class="card activity-card">
    <div class="card-head">
      <h2>Notes &amp; Activity</h2>
    </div>
    <table class="activity-table">
      <thead>
        <tr>
          <th>Timestamp</th>
          <th>Category</th>
          <th>Action</th>
          <th>Comment</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of activityFeed">
          <td>{{ row.at }}</td>
          <td>{{ row.category }}</td>
          <td>{{ row.action }}</td>
          <td>{{ row.comment }}</td>
        </tr>
        <tr *ngIf="!activityFeed.length">
          <td colspan="4" class="empty-hint">No activity recorded.</td>
        </tr>
      </tbody>
    </table>
  </div> -->

  <!-- Goals -->
  <div class="card goals-wrap" id="hospital-goals">
    <div class="goals-head">
      <h2>Hospital Goals</h2>
      <div class="quarter-nav">
        <!-- Past quarters (revealed on toggle) -->
        <div class="quarter-tabs past-tabs" *ngIf="showPastQuarters && pastQuarters.length">
          <button
            type="button"
            class="q-tab past"
            *ngFor="let q of pastQuarters"
            [class.active]="q.quarterName === selectedQuarter"
            (click)="selectQuarterTab(q.quarterName)"
          >
            {{ q.quarterName }}
          </button>
        </div>
        <!-- Current + future quarters -->
        <div class="quarter-tabs">
          <button
            type="button"
            class="q-tab"
            *ngFor="let q of activeQuarters"
            [class.active]="q.quarterName === selectedQuarter"
            (click)="selectQuarterTab(q.quarterName)"
          >
            {{ q.quarterName }}
          </button>
        </div>
        <button
          type="button"
          class="prev-quarters-link"
          (click)="togglePastQuarters()"
          *ngIf="pastQuarters.length"
        >
          {{ showPastQuarters ? '« Hide previous quarters' : 'View goals from previous quarters »' }}
        </button>
      </div>
    </div>

    <div class="goals-toolbar">
      <p-multiSelect class="filter-select" [(ngModel)]="filterGoalStatuses"
                  [options]="goalStatusOptions" optionLabel="label" optionValue="value"
                  placeholder="Filter by Status..." [showClear]="true"
                  [filter]="true" [maxSelectedLabels]="1" selectedItemsLabel="{0} statuses selected"
                  appendTo="body"></p-multiSelect>
      <p-multiSelect class="filter-select" [(ngModel)]="filterExecutionHealths"
                  [options]="executionHealthOptions" optionLabel="label" optionValue="value"
                  placeholder="Filter by Execution Health..." [showClear]="true"
                  [filter]="true" [maxSelectedLabels]="1" selectedItemsLabel="{0} selected"
                  appendTo="body"></p-multiSelect>
      <button type="button" class="btn-teal" (click)="openAssignGoal()">
        Assign New Goal +
      </button>
      <button type="button" class="btn-ghost" (click)="clearGoalFilters()">Reset filters</button>
    </div>

    <!-- Live Goals -->
    <ng-container *ngIf="!isLoadingGoals; else goalsLoader">
    <div class="goal-section">
      <h3 class="section-title live-title">
        <span class="live-check">✓</span>
        Live Goals
      </h3>
      <div class="goal-card" *ngFor="let goal of liveGoals">
        <div class="goal-row" (click)="toggleGoal(goal.goalTargetId)">
          <div class="goal-left">
            <span class="status-dot" [ngClass]="goal.status"></span>
            <span class="goal-name">{{ goal.goalName }}</span>
          </div>
          <div class="goal-right">
            <div class="ops-bar" *ngIf="goal.opsScore !== null">
              <span>OPS</span>
              <div class="bar"><div class="fill" [style.width]="(goal.opsScore > 100 ? 100 : goal.opsScore) + '%'"></div></div>
              <span>{{ goal.opsScore | number:'1.0-0' }}%</span>
            </div>
            <span *ngIf="goal.opsScore === null" class="no-data-text">No Data</span>
            <span
              class="rm-pill"
              [ngClass]="getRmAttentionRequiredClass(goal.rmActionRequired || goal.rMActionRequired)"
            >
              {{ getRmAttentionRequiredLabel(goal.rmActionRequired || goal.rMActionRequired) }}
            </span>
            <span class="material-icons chev">chevron_right</span>
          </div>
        </div>

        <div class="goal-expanded" *ngIf="isGoalExpanded(goal.goalTargetId)">
          <table class="goal-detail-table">
            <thead>
              <tr>
                <th>OPS Score</th>
                <th>Pace</th>
                <th>Status</th>
                <th>Momentum</th>
                <th>Task Health</th>
                <th>Execution Health</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div *ngIf="goal.opsScore !== null" class="ops-inline">
                    {{ goal.opsScore | number:'1.0-0' }}%
                    <div class="bar sm"><div class="fill" [style.width]="(goal.opsScore > 100 ? 100 : goal.opsScore) + '%'"></div></div>
                  </div>
                  <span *ngIf="goal.opsScore === null" class="no-data-text">No Data</span>
                </td>
                <td>{{ formatGoalPacePercent(goal) || 'No Data' }}</td>
                <td>
                  <span *ngIf="goal.status && goal.status !== 'NoData'" class="status-pill" [ngClass]="normalizeStatusClass(goal.status)">{{ getStatusLabel(goal.status) }}</span>
                  <span *ngIf="!goal.status || goal.status === 'NoData'" class="no-data-text">No Data</span>
                  <div class="workflow-sub" *ngIf="getGoalWorkflowLabel(goal)">{{ getGoalWorkflowLabel(goal) }}</div>
                </td>
                <td>
                  <span *ngIf="!isOnTrackStatus(goal.status) && goal.momentum" class="mom" [ngClass]="getMomentumClass(goal.momentum)">
                    <span class="material-icons">{{ getMomentumIcon(goal.momentum) }}</span>
                    {{ getMomentumLabel(goal.momentum) }}
                  </span>
                  <span *ngIf="isOnTrackStatus(goal.status) || !goal.momentum">—</span>
                </td>
                <td>
                  <button
                    type="button"
                    class="linkish"
                    *ngIf="getHospitalTaskInfos([goal]).length"
                    (click)="$event.stopPropagation(); openViewTask(getHospitalTaskInfos([goal]), 'goals')"
                  >
                    {{ getTotalCompletedTaskCount([goal]) }} / {{ getTotalAssignedTaskCount([goal]) }}
                  </button>
                  <span *ngIf="!getHospitalTaskInfos([goal]).length">
                    {{ getTotalCompletedTaskCount([goal]) }} / {{ getTotalAssignedTaskCount([goal]) }}
                  </span>
                </td>
                <td>
                  <span class="exec-txt" [ngClass]="getExecutionHealthClass(goal.executionHealth)">
                    {{ getExecutionHealthLabel(goal.executionHealth) }}
                  </span>
                </td>
                <td>
                  <button type="button" class="view-btn" (click)="$event.stopPropagation(); viewGoalPage(goal)">
                    <span class="material-icons">visibility</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <p *ngIf="!liveGoals.length" class="empty-hint">No live goals for the current filters.</p>
    </div>

    <!-- Pending Review (VP/DO Review, RM Review workflow — not RM Action Required bucket) -->
    <div class="goal-section review">
      <h3 class="section-title review-title">
        <span class="material-icons warn">warning_amber</span>
        Pending Review
      </h3>
      <div class="goal-card review-card" *ngFor="let goal of pendingReviewGoals">
        <div class="goal-row" (click)="toggleGoal(goal.goalTargetId)">
          <div class="goal-left">
            <span class="status-dot" [ngClass]="goal.status"></span>
            <div class="goal-name-block">
              <span class="goal-name">{{ goal.goalName }}</span>
              <span class="workflow-chip" *ngIf="getGoalWorkflowLabel(goal)">{{ getGoalWorkflowLabel(goal) }}</span>
            </div>
          </div>
          <div class="goal-right">
            <div class="ops-bar" *ngIf="goal.opsScore !== null">
              <span>OPS</span>
              <div class="bar"><div class="fill" [style.width]="(goal.opsScore > 100 ? 100 : goal.opsScore) + '%'"></div></div>
              <span>{{ goal.opsScore | number:'1.0-0' }}%</span>
            </div>
            <span *ngIf="goal.opsScore === null" class="no-data-text">No Data</span>
            <span
              class="rm-pill action-required clickable-action"
              [matMenuTriggerFor]="goalActionMenu"
              [matMenuTriggerData]="{ goal: goal }"
              (click)="$event.stopPropagation()"
            >
              Action
            </span>
            <span class="material-icons chev">chevron_right</span>
          </div>
        </div>

        <div class="goal-expanded" *ngIf="isGoalExpanded(goal.goalTargetId)">
          <table class="goal-detail-table">
            <thead>
              <tr>
                <th>OPS Score</th>
                <th>Pace</th>
                <th>Status</th>
                <th>Momentum</th>
                <th>Task Health</th>
                <th>Execution Health</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div *ngIf="goal.opsScore !== null" class="ops-inline">
                    {{ goal.opsScore | number:'1.0-0' }}%
                    <div class="bar sm"><div class="fill" [style.width]="(goal.opsScore > 100 ? 100 : goal.opsScore) + '%'"></div></div>
                  </div>
                  <span *ngIf="goal.opsScore === null" class="no-data-text">No Data</span>
                </td>
                <td>{{ formatGoalPacePercent(goal) || 'No Data' }}</td>
                <td>
                  <span *ngIf="goal.status" class="status-pill" [ngClass]="normalizeStatusClass(goal.status)">{{ getStatusLabel(goal.status) }}</span>
                  <span *ngIf="!goal.status" class="no-data-text">No Data</span>
                  <div class="workflow-sub" *ngIf="getGoalWorkflowLabel(goal)">{{ getGoalWorkflowLabel(goal) }}</div>
                </td>
                <td>
                  <span *ngIf="goal.momentum" class="mom" [ngClass]="getMomentumClass(goal.momentum)">
                    <span class="material-icons">{{ getMomentumIcon(goal.momentum) }}</span>
                    {{ getMomentumLabel(goal.momentum) }}
                  </span>
                  <span *ngIf="!goal.momentum">—</span>
                </td>
                <td>
                  <button
                    type="button"
                    class="linkish"
                    *ngIf="getHospitalTaskInfos([goal]).length"
                    (click)="$event.stopPropagation(); openViewTask(getHospitalTaskInfos([goal]), 'goals')"
                  >
                    {{ getTotalCompletedTaskCount([goal]) }} / {{ getTotalAssignedTaskCount([goal]) }}
                  </button>
                  <span *ngIf="!getHospitalTaskInfos([goal]).length">
                    {{ getTotalCompletedTaskCount([goal]) }} / {{ getTotalAssignedTaskCount([goal]) }}
                  </span>
                </td>
                <td>
                  <span class="exec-txt" [ngClass]="getExecutionHealthClass(goal.executionHealth)">
                    {{ getExecutionHealthLabel(goal.executionHealth) }}
                  </span>
                </td>
                <td>
                  <button type="button" class="view-btn" (click)="$event.stopPropagation(); viewGoalPage(goal)">
                    <span class="material-icons">visibility</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <p *ngIf="!pendingReviewGoals.length" class="empty-hint">No goals pending review for the current filters.</p>
    </div>
    </ng-container>
    <ng-template #goalsLoader>
      <div class="section-loader">
        <div class="simple-spinner"></div>
      </div>
    </ng-template>
  </div>
</div>

<mat-menu #goalActionMenu="matMenu" class="goal-action-menu">
  <ng-template matMenuContent let-goal="goal">
    <div class="menu-header">
      <span class="menu-title">Goal Actions</span>
    </div>
    <button mat-menu-item (click)="viewGoalPage(goal)">
      <mat-icon>visibility</mat-icon>
      <span>View Details</span>
    </button>
    <button mat-menu-item (click)="editGoal(goal)" *ngIf="isAdminLtk">
      <mat-icon>edit</mat-icon>
      <span>Edit Goal</span>
    </button>
    <div class="menu-divider" *ngIf="isAdminLtk"></div>
    <button mat-menu-item class="delete-item" (click)="deleteGoal(goal)" *ngIf="isAdminLtk">
      <mat-icon>delete</mat-icon>
      <span>Delete Goal</span>
    </button>
  </ng-template>
</mat-menu>
